export const REDUCER_KEY = 'counterOfferProposal';
